export default __webpack_public_path__ + "static/media/quickswap-logo.fccc1550.png";